/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useRef, useState } from 'react'
import ReactHtmlParser from 'react-html-parser'
import { Dialog, Transition } from '@headlessui/react'
import { QuestionMarkCircleIcon } from '@heroicons/react/outline'


export const ConfirmDialog = ({
    open,
    setOpen,
    title='Question',
    description='Description',
    isHtmlDescription=false,
    confirmLabel="Yes",
    cancelLabel = "No",
    hideCancel = false,
    onConfirm = () => setOpen(false),
    onCancel = () => {
        if (!loading) {setOpen(false)}
    },
    loading = false,
    loadingLabel = "Loading",
    type = 'default',
    // Fires once the leave transition has fully finished (forwarded to
    // Transition.Root). While the dialog is transitioning out, Headless UI
    // still holds its focus trap — a parent that wants to move the focus
    // (e.g. back to the packing scan input) must wait for this.
    afterLeave = undefined
}) => {

    const getConfirmButtonClass = () => {
        if (type === 'danger') {
            return "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:col-start-2 sm:text-sm"
        }
        return "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:col-start-2 sm:text-sm"
    }

    const cancelButtonRef = useRef()

    return (
        <Transition.Root show={open} as={Fragment} afterLeave={afterLeave}>
            <Dialog
                as="div"
                static
                className="fixed z-10 inset-0 overflow-y-auto"
                initialFocus={cancelButtonRef}
                open={open}
                onClose={(value) => {
                    if( loading===false ) {
                        setOpen(value)
                    }
                }}
            >
                <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    {/* This element is to trick the browser into centering the modal contents. */}
                    <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                        &#8203;
                    </span>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                            <div>
                                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100">
                                    <QuestionMarkCircleIcon className="h-6 w-6 text-yellow-600" aria-hidden="true" />
                                </div>
                                <div className="mt-3 text-center sm:mt-5">
                                    <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                                        {title}
                                    </Dialog.Title>
                                    <div className="mt-2">
                                        <div className="text-sm text-gray-500 scrollable" style={{maxHeight: '50vh', overflowY: 'auto'}}>
                                            {isHtmlDescription ==  true ? (
                                                 <div>{ReactHtmlParser(description)}</div>

                                            ) : (
                                                <>
                                            {description}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={`mt-5 sm:mt-6 ${hideCancel ? '' : 'sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense'}`}>
                                {loading ? <label className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-gray-100 text-base font-medium text-gray-800 sm:col-start-2 sm:text-sm">
                                    {loadingLabel}
                                </label> : <button
                                    type="button"
                                    className={getConfirmButtonClass()}
                                    onClick={onConfirm}
                                >
                                    {confirmLabel}
                                </button>}
                                {!hideCancel && <button
                                    type="button"
                                    className={`mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 text-base font-medium sm:mt-0 sm:col-start-1 sm:text-sm ${loading ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-white text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'}`}
                                    onClick={onCancel}
                                    disabled={loading}
                                    ref={cancelButtonRef}
                                >
                                    {cancelLabel}
                                </button>}
                            </div>
                        </div>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition.Root>
    )
}